import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/bus/busSpeakerLevel/list',params);
    },
  
    add(params) {
      return common.postForm('/rocheManage/bus/busSpeakerLevel/add',params);
    },
  
    edit(params) {
      return common.putForm('/rocheManage/bus/busSpeakerLevel/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/bus/busSpeakerLevel/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/bus/busSpeakerLevel/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/bus/busSpeakerLevel/exportXls', params, {responseType: 'blob'});
    },
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/speakerlevel.js